import { I18n } from "@ies/starling_intl";
import { Tag, Menu, Button } from "@arco-design/web-react";
import { IconList, IconPlus } from "@arco-design/web-react/icon";
import { useCommonModel } from "@/models";
import { QualityOnlyverifyPermission, api } from "@/apis";
import React, { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { IconFont } from "./IconFont";
import "./componentStyle.css";
import { baseURL } from "@/common/const";
import { AXIOS_ENV_URL } from "@/utils/env";
import { OnlySearchPermissions } from "@/components/data";
// import { LeaveCaseModal } from './LeaveCaseModal';

interface AppSideNavProps {
  collapsed: boolean;
  projectID: number;
  navType: string;
}

interface MenuItemProps {
  key: string;
  title: React.ReactNode;
  auth?: string[];
  url?: string;
  query?: string;
  extra?: () => void;
  children?: MenuItemProps[];
}
const WhiteApp = [32, 61, 141, 293];
const AppSideNav: React.FC<AppSideNavProps> = props => {
  const { collapsed, projectID, navType } = props;
  const [curAid, setCurAid] = useState(0);
  const [gmAuth, setGmAuth] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isCodeAdmin, setIsCodeAdmin] = useState(false);
  /**判断当前的BPO用户有没有预审的权限*/
  const [auditionAuth, setAuditionAuth] = useState(false);
  const [selectKeys, setSelectKeys] = useState<string[]>([
    "testManagement",
    "transferTask",
    "storeManagement",
    "issues",
    "preview",
    "workload",
  ]);
  const [{ userInfo, projectInfo }] = useCommonModel();
  const [openKeys, setOpenKeys] = useState<string[]>([
    "testManagement",
    "transferTask",
    "storeManagement",
    "issues",
    "preview",
    "workload",
  ]);
  const [opened, setOpened] = useState([
    "storeManagement",
    "issues",
    "preview",
    "workload",
  ]);
  const history = useHistory();
  /** 点击跳转上线质量标准页面的url */
  const [qualityStandardUrl, setQualityStandardUrl] = useState("");
  /** 点击跳转的运营日报的链接 */
  const [qualityReportUrl, setQualityReportUrl] = useState("");

  const testManagement: MenuItemProps[] = [
    {
      key: "testManagement",
      title: (
        <span>
          <IconFont type="icontest" />
          {I18n.t("test_management", {}, "测试管理")}
        </span>
      ),
      children: [
        {
          key: "transferOrder",
          url: `/${projectID}/testManagement/transferOrder`,
          title: (
            <span
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}>
              <span
                style={{
                  marginRight: 10,
                  flexBasis: "70%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}>
                {I18n.t("transfer_test_sheet", {}, "转测单")}
              </span>
              <Button
                type="primary"
                size="mini"
                disabled={userInfo.isBpo || false}
                icon={<IconPlus style={{ color: "white", marginRight: 0 }} />}
                onClick={e => {
                  e.stopPropagation();
                  history.push(
                    `/${projectID}/testManagement/transferOrder/add`,
                  );
                }}
              />
            </span>
          ),
        },
        {
          key: "transferTask",
          url: `/${projectID}/testManagement/transferTask`,
          title: <span>{I18n.t("test_task", {}, "测试任务")}</span>,
        },
        {
          key: "schedule",
          auth: ["internal"],
          url: `/${projectID}/testManagement/schedule`,
          title: <span>{I18n.t("human_view", {}, "人力视图")}</span>,
        },
        {
          key: "testCase",
          url: `/${projectID}/testManagement/testCase`,
          query: "type=3",
          title: <span>{I18n.t("test_case", {}, "测试用例")}</span>,
        },
        {
          key: "wrapManage",
          url: `/${projectID}/testManagement/wrapManage`,
          title: (
            <span>{I18n.t("testing_suite_management", {}, "测试包管理")}</span>
          ),
        },
        {
          key: "testReport",
          url: `/${projectID}/testManagement/testReport`,
          title: <span>产出文档</span>,
        },
      ],
    },
    {
      key: "storeManagement",
      auth: ["internal", "project_bpo_tester"],
      title: (
        <span>
          <IconFont type="iconreview" />
          {I18n.t("store_management", {}, "商店管理")}
        </span>
      ),
      children: [
        {
          key: "storeManagement/ios",
          auth: ["project_bpo_tester"],
          title: (
            <span
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}>
              {I18n.t("ios_audit", {}, "iOS审核")}
              <Button
                type="primary"
                size="mini"
                icon={<IconPlus style={{ color: "white", marginRight: 0 }} />}
                onClick={e => {
                  e.stopPropagation();
                  history.push(`/${projectID}/storeManagement/ios/add`);
                }}
              />
            </span>
          ),
          url: `/${projectID}/storeManagement/ios`,
        },
        {
          key: "exteranlTF",
          auth: ["internal"],
          url: `/${projectID}/storeManagement/externalTF`,
          title: <span>Testflight</span>,
        },
        {
          key: "storeManagement/google",
          auth: ["project_bpo_tester"],
          url: `/${projectID}/storeManagement/google`,
          title: (
            <span
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}>
              {I18n.t("gp_audit", {}, "GP审核")}
              <Button
                size="mini"
                type="primary"
                icon={<IconPlus style={{ color: "white", marginRight: 0 }} />}
                onClick={e => {
                  e.stopPropagation();
                  history.push(`/${projectID}/storeManagement/google/add`);
                }}
              />
            </span>
          ),
        },
      ],
    },
    {
      key: "operationManagement",
      auth: ["internal", "external"],
      title: (
        <span>
          <IconFont type="Iconoperation" />
          {I18n.t("operation_management", {}, "运营管理")}
        </span>
      ),
      children: WhiteApp.includes(projectID)
        ? [
            {
              key: "ro_test",
              title: <span>{I18n.t("ro_test", {}, "RO质量平台")}</span>,
              url: `/${projectID}/operationManagement/ro`,
            },
            {
              key: "quality-dashboard",
              title: (
                <span>{I18n.t("quality_check_version", {}, "质量看版")}</span>
              ),
              url: `/${projectID}/operationManagement/quality-dashboard`,
            },
            {
              key: "gameOperation",
              url: `/${projectID}/operationManagement/gameOperation`,
              title: (
                <span>
                  {I18n.t("operation_and_maintenance_release", {}, "运维发布")}
                </span>
              ),
            },
            {
              key: "daily",
              url: qualityReportUrl,
              title: (
                <span>
                  {I18n.t("operational_quality_report", {}, "运营质量报告")}
                </span>
              ),
            },
            {
              key: "projectIssue",
              auth: ["internal"],
              url: `/${projectID}/operationManagement/issues/overview`,
              title: <span>{I18n.t("online_problem", {}, "线上问题")}</span>,
            },
            {
              key: "standard",
              auth: ["internal"],
              url: qualityStandardUrl,
              title: (
                <span>
                  {I18n.t("online_quality_standards", {}, "上线质量标准")}
                </span>
              ),
            },
          ]
        : [
            {
              key: "quality-dashboard",
              title: (
                <span>{I18n.t("quality_check_version", {}, "质量看版")}</span>
              ),
              url: `/${projectID}/operationManagement/quality-dashboard`,
            },
            {
              key: "gameOperation",
              url: `/${projectID}/operationManagement/gameOperation`,
              title: (
                <span>
                  {I18n.t("operation_and_maintenance_release", {}, "运维发布")}
                </span>
              ),
            },
            {
              key: "daily",
              url: qualityReportUrl,
              title: (
                <span>
                  {I18n.t("operational_quality_report", {}, "运营质量报告")}
                </span>
              ),
            },
            {
              key: "projectIssue",
              auth: ["internal"],
              url: `/${projectID}/operationManagement/issues/overview`,
              title: <span>{I18n.t("online_problem", {}, "线上问题")}</span>,
            },
            {
              key: "standard",
              auth: ["internal"],
              url: qualityStandardUrl,
              title: (
                <span>
                  {I18n.t("online_quality_standards", {}, "上线质量标准")}
                </span>
              ),
            },
          ],
    },
  ];

  const overview: MenuItemProps[] = [
    {
      key: "projectOverview",
      title: (
        <span>
          <IconList />
          {I18n.t("project_overview", {}, "项目概况")}
        </span>
      ),
      url: "/online-market",
    },
    {
      key: "workload",
      // auth: ['internal', 'bpo'],
      title: (
        <span>
          <IconFont type="iconstatistics" />
          {I18n.t("workload_management", {}, "工作量管理")}
        </span>
      ),
      children: [
        {
          key: "workload/bpo-overview",
          title: <span>{I18n.t("workload_data", {}, "工作量数据")}</span>,
          auth: ["admin"],
          url: `/workload/bpo-overview`,
        },
        {
          key: "workload/data-entry",
          title: <span>{I18n.t("data_entry", {}, "数据录入")}</span>,
          url: `/workload/bpo-data-entry`,
        },
      ],
    },
    {
      key: "stats",
      title: (
        <span>
          <IconFont type="iconstatistics2" />
          {I18n.t("usage_overview", {}, "使用概况")}
        </span>
      ),
      query: `startDate=${moment()
        .add("days", -7)
        .startOf("days")
        .unix()}&endDate=${moment().add("days", -1).endOf("days").unix()}`,
      url: `/qa-weekly`,
    },
    {
      key: "issues",
      title: (
        <span>
          <IconFont type="iconbug" />
          {I18n.t("online_problem", {}, "线上问题")}
        </span>
      ),
      children: [
        {
          key: "issueOverview",
          url: `/issues/overview`,
          title: <span>{I18n.t("problem_overview", {}, "问题总览")}</span>,
        },
        {
          key: "issueStats",
          url: `/issues/stats`,
          title: <span>{I18n.t("kanban_statistics", {}, "看板统计")}</span>,
        },
        {
          key: "issuehierachy",
          url: `/issues/hierarchy`,
          title: <span>{I18n.t("project_configuration", {}, "项目配置")}</span>,
        },
      ],
    },
    {
      key: "online-quality",
      title: (
        <span>
          <IconFont type="iconoverview" />
          {I18n.t("online_quality_standards_overview", {}, "上线质量标准总览")}
        </span>
      ),
      url: `/online-quality`,
    },
    {
      key: "managePlatform",
      title: (
        <span>
          <IconFont type="iconmanage" />
          {I18n.t("platform_management", {}, "平台管理")}
        </span>
      ),
      url: `/work-order`,
    },
    {
      key: "onlinestatus/list",
      url: `/onlinestatus/list/apple`,
      title: (
        <span>
          <IconFont type="iconrobot" />
          {I18n.t("project_online_status_monitoring", {}, "项目线上状态监控")}
        </span>
      ),
    },
    {
      key: "preview",
      title: (
        <span>
          <IconFont type="iconshenhe1" />
          {I18n.t("committal_hearing_management", {}, "预审管理")}
        </span>
      ),
      children: [
        {
          key: "allqareview",
          url: `/allqareviewing/list`,
          title: (
            <span>
              {I18n.t("summary_of_qa_committal_hearings", {}, "QA预审单汇总")}
            </span>
          ),
        },
      ],
    },
    {
      key: "certsManagement",
      title: (
        <span>
          <IconFont type="iconcertificate" />
          证书管理
        </span>
      ),
      url: `/certs-management/overview`,
    },
  ];

  const toolboxNav: MenuItemProps[] = [
    {
      key: "testTools",
      title: (
        <span>
          <IconFont type="icontool" />
          {I18n.t("test_tools", {}, "测试工具")}
        </span>
      ),
      children: [
        {
          key: "testTool",
          title: (
            <span>{I18n.t("testing_suite_re_sign", {}, "测试包重签")}</span>
          ),
          url: `/${projectID}/hold-all/re-sign-package`,
        },
        {
          key: "code-coverage",
          auth: ["code"],
          title: <span>覆盖率采集</span>,
          url: `/${projectID}/code-coverage`,
        },
        {
          key: "interfacetestTool",
          auth: ["hamlet"],
          title: (
            <span>
              {I18n.t("interface_automation_test", {}, "接口自动化测试")}
            </span>
          ),
          url: `/${projectID}/interfacetest`,
        },
        {
          key: "gmTool",
          auth: ["j1"],
          title: <span>{I18n.t("gm_directive", {}, "GM指令")}</span>,
          url: `/${projectID}/gm-config`,
        },
      ],
    },
    {
      key: "shopTool",
      auth: ["internal", "external"],
      title: (
        <span>
          <IconFont type="iconshop" />
          {I18n.t("shop_tools", {}, "商店工具")}
        </span>
      ),
      children: [
        {
          key: "recommend",
          auth: ["internal"],
          url: `/${projectID}/recommend`,
          title: (
            <span>
              {I18n.t("store_recommendation_application", {}, "商店推荐申请")}
            </span>
          ),
        },
        {
          key: "certManage",
          url: `/${projectID}/certManage`,
          title: (
            <span>
              {I18n.t(
                "apple_store_certificate_management",
                {},
                "Apple商店证书管理",
              )}
            </span>
          ),
        },
        {
          key: "gameOperation",
          url: `/${projectID}/review/apple/iap`,
          title: (
            <span>
              {I18n.t("apple_store_iap_view", {}, "Apple商店IAP查看")}
            </span>
          ),
        },
        {
          key: "googleIAP",
          url: `/${projectID}/review/google/iap`,
          title: (
            <span>
              {I18n.t("google_store_iap_view", {}, "Google商店IAP查看")}
            </span>
          ),
        },
      ],
    },
    {
      key: "pkgTool",
      title: (
        <span>
          <IconFont type="iconcube" />
          {I18n.t("package_inspection_tool", {}, "包检查工具")}
        </span>
      ),
      children: [
        {
          key: "protection",
          title: (
            <span>
              {I18n.t("game_pack_reinforcement_check", {}, "游戏包加固检查")}
            </span>
          ),
          url: `/${projectID}/protection`,
        },
        {
          key: "static-channel",
          title: (
            <span>{I18n.t("static_channel_check", {}, "静态渠道检查")}</span>
          ),
          url: `/${projectID}/package-inspection/static-channel`,
        },
        {
          key: "exteranlTF",
          url: `/${projectID}/storeManagement/ios/reveal-scan`,
          title: (
            <span>
              {I18n.t("ios_/gp_committal_hearing_scan", {}, "iOS/GP预审扫描")}
            </span>
          ),
        },
        {
          key: "privacy-scan",
          title: (
            <span>
              {I18n.t("privacy_compliance_check", {}, "隐私合规检查")}
            </span>
          ),
          url: `/${projectID}/privacy-scan`,
        },
      ],
    },
  ];

  /** 选择对应的navbar */
  const navBarList = useMemo(() => {
    switch (navType) {
      case "toolbox":
        return toolboxNav;
      case "testmanagement":
        return testManagement;
      case "overview":
        return overview;
      default:
        return testManagement;
    }
  }, [navType, qualityStandardUrl, qualityReportUrl]);

  /** active对应的menu item */
  const getActiveBar = (v: MenuItemProps[]) => {
    // const curPath = location.pathname;
    let keys: string[] = [];
    if (history.location.pathname.includes("newTransferOrder")) {
      // 新建转测单
      return ["testManagement", "transferOrder"];
    } else if (
      history.location.pathname.includes("operationManagement/quality-weekly")
    ) {
      // 日报和周报高亮运营质量报告
      return ["operationManagement", "daily"];
    } else if (
      location.pathname.includes("multipleUseCases") ||
      location.pathname.includes("createUseCaseSet")
    ) {
      // 新建多条用例，新建用例集高亮测试用例
      return ["testManagement", "testCase"];
    } else if (location.pathname.includes("issues/process/")) {
      const nav = localStorage.getItem("nav_type");
      return nav === "overview"
        ? ["issues", "issueOverview"]
        : ["operationManagement", "projectIssue"];
    }
    for (const bar of v) {
      if (bar.children !== undefined) {
        const res = getActiveBar(bar.children);
        if (res.length > 0) {
          keys = [bar.key, ...res];
        } else {
          continue;
        }
      } else if (
        bar.url === location.pathname ||
        location.pathname.includes(bar.key)
      ) {
        keys = [bar.key];
      } else if (
        bar.url !== undefined &&
        bar.extra !== undefined &&
        location.pathname.includes(bar.url)
      ) {
        keys = [bar.key];
      } else {
        continue;
      }
    }
    return keys;
  };
  /** 点击跳转运营质量日报 */
  const jumpQualityReport = async () => {
    try {
      const data = await api.get(
        `/v1/projects/report/latest?project_id=${projectID}&range=${"daily"}`,
        {},
      );
      if (data) {
        setQualityReportUrl(
          `/${projectID}/operationManagement/quality-daily/${data.report_id}/preview/daily`,
        );
      }
    } catch (error) {}
  };

  /** 获取标准周期 */
  const getPeriod = async () => {
    // setStandardJumpFlag(false);
    try {
      const data = await api.get(
        `/v1/projects/standard/check/detail?project_id=${projectID}`,
        {},
      );
      if (data) {
        getPermissions(data.period, data);
      } else {
        getPermissions(0, {});
      }
    } catch (err) {
      // setStandardJumpFlag(true);
      getPermissions(0, {});
    }
  };
  /** 判断当前的用户有没有提审包上传的权限 */
  const checkPermission = async () => {
    QualityOnlyverifyPermission(
      "right_bpo_tester_operator",
      projectID,
      true,
    ).then(res => {
      setAuditionAuth(res);
    });
  };
  /**
   * 1.查询是否具有文档编辑权限
   * 2.根据标准周期、当前日期、是否具有编辑权限，判断要跳转的url
   *  */
  const getPermissions = async (period: number, detailData: any) => {
    // setStandardJumpFlag(true);
    if (period && period !== 0) {
      const data = await api.get(
        `/v1/check/perm?project_id=${projectID}&period=${period}`,
        {},
      );
      if (data) {
        if (period) {
          // 0.未开始 1.检查中 2.已完成 3.修订中
          if (detailData.check_state === 1 || detailData.check_state === 3) {
            setQualityStandardUrl(
              `/${projectID}/operationManagement/standard/${
                data.has_perm ? "edit" : "preview"
              }/${period}`,
            );
          } else {
            setQualityStandardUrl(
              `/${projectID}/operationManagement/standard/preview/${period}`,
            );
          }
        }
      }
    } else {
      setQualityStandardUrl(
        `/${projectID}/operationManagement/standard/preview/${0}`,
      );
    }
  };

  /** 查询是否具有超管权限（超管） */
  const getsuperPermissions = async () => {
    const data = await api.get(
      `/v1/access_control/right/check_right?right_keys=right_super_manager&project_id=0`,
    );
    if (data) {
      if (userInfo.id) {
        setIsAdmin(data.right_super_manager);
      }
    }
  };

  /** 查询是否有覆盖率采集工具权限 */
  const codeCoverageAuth = async () => {
    const data = await api.get(
      `/v1/access_control/right/check_right?right_keys=right_code_coverage&project_id=0`,
    );
    if (data) {
      if (data.right_code_coverage) {
        setIsCodeAdmin(data.right_code_coverage);
      }
    }
  };

  /** 查询是否具有GM工具权限 */
  const getGmToolRight = async (pid: number) => {
    const data = await api.get(
      `/v1/access_control/right/check_right?right_keys=right_gm_tool_read&project_id=${pid}`,
    );
    if (data) {
      setGmAuth(data.right_gm_tool_read);
    }
  };

  const checkAuth = (pathPermission: string[] | undefined) => {
    const { isBpo, isInternal, userType } = userInfo;
    if (pathPermission === undefined) {
      return true;
    } else if (pathPermission.includes("admin")) {
      return isAdmin;
    } else if (pathPermission.includes("j1")) {
      return [2682, 362004, 6037].includes(curAid) && (gmAuth || isBpo);
    } else if (pathPermission.includes("hamlet")) {
      return (
        ([290].includes(projectID) && baseURL !== AXIOS_ENV_URL.development) ||
        ([220].includes(projectID) && baseURL === AXIOS_ENV_URL.development)
      );
    } else if (isInternal && userType !== 0) {
      return true;
    } else if (pathPermission.includes("bpo")) {
      return isBpo;
    } else if (pathPermission.includes("code")) {
      return isCodeAdmin;
    } else if (
      pathPermission &&
      pathPermission.includes("project_bpo_tester")
    ) {
      return isBpo && auditionAuth;
    } else {
      const allowExternal = pathPermission.includes("external");
      return allowExternal && !isBpo && userType !== 0;
    }
  };

  useEffect(() => {
    setOpened(["storeManagement", "issues", "preview", "workload"]);
    localStorage.setItem("nav_type", navType);
  }, [navType]);

  useEffect(() => {
    if (
      ![
        "/login",
        "/signout",
        "/",
        "/noPermission/download",
        "/new-project",
      ].includes(location.pathname) &&
      !location.pathname.includes("/interfacetest/sh") &&
      !location.pathname.includes("/share") &&
      !location.pathname.includes("/summary")
    ) {
      // getProjectDetail(projectID);
      getsuperPermissions();
      if (projectID) {
        getGmToolRight(projectID);
        checkPermission();
        codeCoverageAuth();
      }
    }
  }, [projectID]);

  useEffect(() => {
    if (projectInfo) {
      setCurAid(projectInfo?.review_meta?.aid);
    }
  }, [projectInfo]);

  useEffect(() => {
    if (location.pathname === `/${projectID}/setting`) {
      setSelectKeys([]);
      setOpenKeys([]);
    } else {
      const keys = getActiveBar(navBarList).concat(opened);
      setSelectKeys(keys.length ? keys : selectKeys);
      setOpenKeys(keys.length ? keys : openKeys);
    }
    if (
      ![
        "/login",
        "/signout",
        "/",
        "/noPermission/download",
        "/new-project",
      ].includes(location.pathname) &&
      !location.pathname.includes("/interfacetest/sh") &&
      !location.pathname.includes("/share") &&
      !location.pathname.includes("/summary") &&
      projectID
    ) {
      // console.log(projectID,"projectID0-----")
      getPeriod();
      jumpQualityReport();
    }
  }, [projectID, location.pathname, navType]);

  /** 菜单按钮点击操作 */
  const clickMenuItem = (v: MenuItemProps) => {
    if (v.extra !== undefined) {
      v.extra();
    } else if (v.url !== undefined) {
      history.push(`${v.url}${v.query !== undefined ? `?${v.query}` : ""}`);
    }
  };

  /** 生成菜单 */
  const genMenu = (list: MenuItemProps[]) => {
    // console.log(list,"list----")
    const menuList: React.ReactNode[] = [];
    list.forEach(item => {
      if (item.children === undefined) {
        if (checkAuth(item.auth)) {
          menuList.push(
            <Menu.Item
              key={item.key}
              onClick={() => {
                clickMenuItem(item);
              }}>
              {item.title}
            </Menu.Item>,
          );
        }
      } else if (checkAuth(item.auth)) {
        menuList.push(
          <Menu.SubMenu key={item.key} title={item.title}>
            {item.children.map(v => {
              if (checkAuth(v.auth)) {
                return (
                  <Menu.Item key={v.key} onClick={() => clickMenuItem(v)}>
                    {v.title}
                  </Menu.Item>
                );
              } else {
                return null;
              }
            })}
          </Menu.SubMenu>,
        );
      }
    });
    return menuList;
  };

  return (
    <Menu
      collapse={collapsed}
      openKeys={openKeys}
      levelIndent={32}
      selectedKeys={selectKeys}
      triggerProps={{
        style: {
          width: "150px",
          left: "34px",
          display: "block",
        },
        position: "rt",
      }}
      onClickMenuItem={(key, e, keyPath) => {
        setOpened([]);
        setOpenKeys(keyPath);
        setSelectKeys(keyPath);
      }}
      onClickSubMenu={(key, opens, keyPath) => {
        setOpened([]);
        if (openKeys.includes(key)) {
          setOpenKeys([...openKeys].filter(v => v !== key));
        } else {
          setOpenKeys([...keyPath, ...opens]);
        }
      }}>
      {genMenu(navBarList)}
    </Menu>
  );
};

export default AppSideNav;
